import { render, staticRenderFns } from "./AllPurchaseRequests.vue?vue&type=template&id=02614b50"
import script from "./AllPurchaseRequests.vue?vue&type=script&lang=js"
export * from "./AllPurchaseRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports